export type Paginated<T> = {
  items: T[];
  totalCount: number;
  pageCount: number;
  currentPage: number;
};

export type PaginationParams = {
  offset?: number;
  count?: number;
};
